module.exports = __webpack_public_path__ + "img/expired.a1752791.png";